var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7742_39215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8299 8.17935C15.8299 7.65268 15.7833 7.15268 15.7033 6.66602H8.16992V9.67268H12.4833C12.2899 10.6594 11.7233 11.4927 10.8833 12.0593V14.0593H13.4566C14.9633 12.666 15.8299 10.6127 15.8299 8.17935Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1693 16.0007C10.3293 16.0007 12.136 15.2807 13.456 14.0607L10.8826 12.0607C10.1626 12.5407 9.2493 12.834 8.1693 12.834C6.08263 12.834 4.31596 11.4273 3.68263 9.52734H1.0293V11.5873C2.34263 14.2007 5.04263 16.0007 8.1693 16.0007Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68326 9.52739C3.51659 9.04739 3.42992 8.53406 3.42992 8.00073C3.42992 7.46739 3.52326 6.95406 3.68326 6.47406V4.41406H1.02992C0.483255 5.49406 0.169922 6.70739 0.169922 8.00073C0.169922 9.29406 0.483255 10.5074 1.02992 11.5874L3.68326 9.52739Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1693 3.16667C9.3493 3.16667 10.4026 3.57334 11.236 4.36667L13.516 2.08667C12.136 0.793334 10.3293 0 8.1693 0C5.04263 0 2.34263 1.8 1.0293 4.41334L3.68263 6.47334C4.31596 4.57334 6.08263 3.16667 8.1693 3.16667Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7742_39215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.572393e24a3d845ca27a34603cf978ba.svg";
export { ForwardRef as ReactComponent };